(function($) {
	stickyHeader = function() {
		$(window).scroll(function() {
	      if ($(document).scrollTop() > 300) {
	        $(".site-header").addClass("sticky");
	      }
	      else {
	        $(".site-header").removeClass("sticky");
	      }
	    });

	    $('.site-header .mobile-nav-toggle').click(function(){
	      $('body').toggleClass('mobile-nav-open');
	    });

	    $(window).resize(function() {
	      $('body').removeClass('mobile-nav-open');
	    });
	};
})(jQuery); // Fully reference jQuery after this point.
